import React, {useEffect} from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import styled from "styled-components";


import SwiperCore, {Navigation} from "swiper";
import "swiper/swiper-bundle.min.css";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {ApiParam} from "../../api/network/apiParams";
import {fetchWritingDetail} from "../../api/redux/writing";
import ReactHtmlParser from "react-html-parser";

SwiperCore.use([Navigation]);

const UrbanDetails = () => {

    const dispatch = useDispatch()
    const getData = useSelector(store => store.writing)
    let {slug} = useParams();


    // api call
    useEffect(() => {
        let api_url = apiEndPoints.BLOG_DATA

        let api_params = {
            [ApiParam.TYPE]: "slug",
            [ApiParam.VALUE]: slug,
            [ApiParam.IMAGE]: "yes",
            [ApiParam.POST]: "yes",
        };


        dispatch(fetchWritingDetail([api_url, api_params]));

    }, [slug])

    const details = getData?.detail?.data;

    return (
        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{details?.data?.title}</title>
                <meta name="description" content="Description"/>
            </Helmet>

            <StyledComponent>
                <div className="row">
                    <div className="container">
                        <div className="col-lg-12">
                            <h5>{details?.data?.title}</h5>
                            <p>{ReactHtmlParser(details?.data?.body)}</p>
                        </div>
                    </div>
                </div>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`

    h5 {
        font-size: 16px;
        line-height: 18px;
        font-weight: bold;
        margin-bottom: 30px;
    }

    p {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
    }
`;

export default UrbanDetails;
